var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6775 18.2173C20.1984 18.2173 20.7293 18.2251 21.2501 18.2173C21.4504 18.2173 21.4705 18.2799 21.4404 18.3973C21.2501 19.266 20.2785 19.7669 19.1867 19.5634C18.5457 19.4382 17.9247 18.8669 17.9047 18.3816C17.8946 18.2564 17.9347 18.2173 18.105 18.2173C18.6258 18.2251 19.1467 18.2173 19.6775 18.2173Z",
    fill: "#0B1836"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6082 16.9034C22.13 16.8683 21.975 16.6013 21.9683 16.1305C21.9616 15.491 21.9818 14.8446 21.9616 14.2051C21.9481 13.6922 21.7393 13.2495 21.4361 12.8489C21.2879 12.6522 21.1128 12.4906 20.9242 12.3571C20.8838 12.329 20.8501 12.3079 20.8097 12.2798C20.776 12.2587 20.749 12.2446 20.7154 12.2236C20.7086 12.2165 20.7019 12.2165 20.6951 12.2095C20.6547 12.1884 20.6143 12.1673 20.5739 12.1533C20.2977 12.0268 19.9878 11.9565 19.6712 11.9565C19.3546 11.9565 19.0515 12.0268 18.7821 12.1463C18.7753 12.1463 18.7753 12.1533 18.7686 12.1533C18.6473 12.2095 18.5328 12.2727 18.425 12.35C18.3442 12.4063 18.2701 12.4695 18.196 12.5327C18.0882 12.6241 17.9939 12.7295 17.9063 12.8489C17.6032 13.2424 17.3944 13.6922 17.3809 14.2051C17.3607 14.8446 17.3809 15.491 17.3742 16.1305C17.3674 16.6083 17.2125 16.8683 16.7342 16.9034C16.5793 16.9175 16.4715 17.065 16.485 17.2337C16.4917 17.4023 16.6197 17.5218 16.7949 17.5218C17.7581 17.5218 21.5978 17.5218 22.5611 17.5218C22.7362 17.5218 22.8575 17.4023 22.871 17.2337C22.871 17.065 22.7632 16.9175 22.6082 16.9034Z",
    fill: "#0B1836"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9L13.7094 13.7924C13.8832 13.9166 14.1168 13.9166 14.2906 13.7924L21 9",
    stroke: "#0B1836"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.45 18H7.5C7.22386 18 7 17.7761 7 17.5V8.5C7 8.22386 7.22386 8 7.5 8H20.5C20.7761 8 21 8.22386 21 8.5V11.9286",
    stroke: "#0B1836",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeReminder);
export default __webpack_public_path__ + "static/media/envelope-reminder.d567f9786d56e5adcb68cf999f57b348.svg";
export { ForwardRef as ReactComponent };